import React from 'react';
import { StepProps, Specialty, SPECIALTY_COLORS } from '../../types';
import { motion } from 'framer-motion';
import { Droplets, Heart, FlaskConical, Stethoscope, ArrowRight } from 'lucide-react';
export function SpecialtySelection({
  state,
  updateState,
  nextStep
}: StepProps) {
  const roles: {
    id: Specialty;
    icon: React.ElementType;
    label: string;
    tagline: string;
  }[] = [{
    id: 'Nephrologist',
    icon: Droplets,
    label: 'Nephrologist',
    tagline: 'Explore their beliefs, behaviors, and treatment approach'
  }, {
    id: 'Cardiologist',
    icon: Heart,
    label: 'Cardiologist',
    tagline: 'Explore their beliefs, behaviors, and treatment approach'
  }, {
    id: 'Endocrinologist',
    icon: FlaskConical,
    label: 'Endocrinologist',
    tagline: 'Explore their beliefs, behaviors, and treatment approach'
  }, {
    id: 'PCP',
    icon: Stethoscope,
    label: 'PCP',
    tagline: 'Explore their beliefs, behaviors, and treatment approach'
  }];
  const handleSelect = (id: Specialty) => {
    updateState({
      selectedSpecialty: id
    });
  };
  return <div className="flex-grow flex flex-col justify-center items-center px-6 py-12" data-id="element-441">
      <div className="max-w-4xl w-full mx-auto" data-id="element-442">
        <div className="text-center mb-12" data-id="element-443">
          <span className="text-brand font-semibold tracking-wider uppercase text-sm mb-2 block" data-id="element-444">
            Deep Dive
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-dark" data-id="element-445">
            Which specialty would you like to explore?
          </h2>
          <p className="text-gray-500 mt-4 text-lg" data-id="element-446">
            Select a specialty to understand their unique perspective on CKD
            management.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-447">
          {roles.map(role => {
          const Icon = role.icon;
          const isSelected = state.selectedSpecialty === role.id;
          return <motion.button key={role.id} whileHover={{
            scale: 1.02,
            y: -4
          }} whileTap={{
            scale: 0.98
          }} onClick={() => handleSelect(role.id)} className={`
                  relative p-8 rounded-2xl border-2 text-left flex flex-col transition-all duration-300
                  ${isSelected ? 'shadow-lg bg-white' : 'border-gray-100 bg-gray-50/50 hover:bg-white hover:border-gray-200 hover:shadow-md'}
                `} style={{
            borderColor: isSelected ? SPECIALTY_COLORS[role.id] : undefined
          }} data-id="element-448">
                <div className="p-4 rounded-full w-16 h-16 flex items-center justify-center mb-6" style={{
              backgroundColor: `${SPECIALTY_COLORS[role.id]}15`,
              color: SPECIALTY_COLORS[role.id]
            }} data-id="element-449">
                  <Icon size={32} data-id="element-450" />
                </div>
                <h3 className="text-2xl font-bold mb-2 text-dark" data-id="element-451">
                  {role.label}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-452">{role.tagline}</p>

                {isSelected && <motion.div layoutId="outline" className="absolute inset-0 border-2 rounded-2xl pointer-events-none" style={{
              borderColor: SPECIALTY_COLORS[role.id]
            }} initial={false} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-453" />}
              </motion.button>;
        })}
        </div>

        <div className="flex justify-center h-16" data-id="element-454">
          {state.selectedSpecialty && <motion.button initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} onClick={nextStep} className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-dark rounded-full hover:bg-black transition-colors shadow-lg" data-id="element-455">
              Explore this specialty
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-456" />
            </motion.button>}
        </div>
      </div>
    </div>;
}